<template>
  <span :class="className" :style="{fontSize:fontSize}">{{num * 1 >= 10000 ? '9999+': num}}</span>
</template>

<script>
  export default {
    name: "store-warning-num",
    props: {
      num: {
        type: [Number, String],
        default: 0
      },
      fontSize: {
        type: String,
        default: '13px'
      }
    },
    data() {
      return {
      }
    },
    computed: {
      className () {
        return {
          'num': true,
          'highlight': this.num * 1 > 0
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.num {
  color: $title-color-999;
  &.highlight {
    color: #FF3A00;
  }
}
</style>
